import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Select2OptionData } from 'ng-select2';

@Component({
  selector: 'input-select-search',
  templateUrl: './input-select-search.component.html',
  styleUrls: ['./input-select-search.component.css']
})
export class InputSelectSearchComponent {

  @Input() id: string = '';
  @Input() dataSelect: Array<Select2OptionData> = [];
  @Input() options = { placeholder: '', multiple: false, tags: false };
  @Input() control: UntypedFormControl;
  @Input() placeholder: string = '';
  @Input() dropdownParent: string = '';

  constructor() { }

  ngAfterContentInit(): void {
    this.options.placeholder = this.placeholder;
  }
}